import projectsModel from '$$projectModel';
import historyModel from '../../models/history';
import globalStore from '$$globalStore';

const TASK_ATTRIBUTE = 'data-task-id';

const CopyPasteHelpers = {

  prepareDataForCopy(taskId) {
    const task = globalStore.getters['tasksModel/tasksByIds'][taskId];
    const copyData = {
      taskId: +taskId,
      ganttId: task.gantt_id,
      text: task.text,
      siblingId: +taskId,
    };

    if (task.$level === 0) {
      const projectData = projectsModel.getProjectDataById(task.gantt_id);

      copyData.text = projectData.name;
    }

    return copyData;
  },

  prepareDataForPaste(data, config) {
    // statusHelper.handlers.showMainSpinner();

    const sibling = globalStore.getters['tasksModel/tasksByIds'][data.taskId];

    const actionHash = historyModel.generateActionHash();

    return {
      ...config,
      newGanttId: sibling.gantt_id,
      siblingId: sibling.id,
      parentId: sibling.parent,
      before: data.before,
      convertToParent: false,
      actionHash,
    };
  },

  calculateSpecialPopupCoordinates(taskId) {
    const targetNode = document.querySelector(`[${TASK_ATTRIBUTE}="${taskId}"] .column-options-cog.icon-dots`);

    if (!targetNode) return;

    const coordinates = targetNode.getBoundingClientRect();
    const popupWidth = 292;
    const popupHeight = 450;
    const clientWidth = document.documentElement.clientWidth;
    const popupCoordinates = {
      bottom: `${0}px`,
      left: `${0}px`,
    };

    if (clientWidth - coordinates.right < popupWidth) {
      popupCoordinates.left = `${coordinates.left - popupWidth}px`;
    } else {
      popupCoordinates.left = `${coordinates.right}px`;
    }

    if (coordinates.bottom <= popupHeight + 115) {
      popupCoordinates.top = '116px';
      popupCoordinates.bottom = 'auto';
    } else {
      popupCoordinates.top = 'auto';
      popupCoordinates.bottom = '0px';
    }

    return popupCoordinates;
  },
};

export default CopyPasteHelpers;
